(() => {
  function associate() {
    document.querySelectorAll('product-info').forEach(container => {
      const form = container.querySelector('form[data-product-form]');
      if (!form) return;
      const buttonPrice = form.querySelector('[data-product-price]');
      const selected = container.querySelector('input[name="selling_plan"]:checked');
      const subscriptionPrice = container.querySelector('.appstle_subscription_amount');
      if (buttonPrice && selected && subscriptionPrice) {
        if (!buttonPrice.hasAttribute('data-pb-base-price')) buttonPrice.setAttribute('data-pb-base-price', buttonPrice.textContent);
        const price = selected.value && selected.value !== '0' ? subscriptionPrice.textContent : buttonPrice.getAttribute('data-pb-base-price');
        if (buttonPrice.textContent !== price) buttonPrice.textContent = price;
      }
      container.querySelectorAll('[class*="appstle"] input[name]').forEach(input => {
        if (input.getAttribute('form') !== form.getAttribute('id')) input.setAttribute('form', form.getAttribute('id'));
      });
    });
  }
  associate();
  new MutationObserver(associate).observe(document.body, { childList: true, characterData: true, subtree: true });
  document.addEventListener('change', () => requestAnimationFrame(associate));
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!form.matches('form[data-product-form]')) return;
    const container = form.closest('product-info');
    const selected = container?.querySelector('input[name="selling_plan"]:checked');
    if (selected?.value && selected.value !== '0') event.formData.set('selling_plan', selected.value);
    else if (selected) event.formData.delete('selling_plan');
  });
})();